import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";

import Imagen3 from "../../../images/modulo12/iguales.png";
import Imagen4 from "../../../images/modulo12/saludos.png";
import Imagen5 from "../../../images/modulo12/regalos.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[12];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[10].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[10].path}`,
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[0].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[0].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5">
        <h2>¿Cómo convivimos siendo diferentes?</h2>
        <div className="row align-items-center mt-3">
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              ¿Todos somos iguales o somos todos distintos? Lo que importa es
              que todos tenemos <strong>los mismos derechos</strong>, sin
              importar las diferencias.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen3} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen4} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              No importa de dónde venimos, cómo somos o cómo hablamos. Todos
              tenemos el derecho de ser respetados. Todos tenemos{" "}
              <strong>la obligación de respetar</strong> a los demás. El Estado
              (los gobernantes, las oficinas, las leyes) debe garantizar
              nuestros derechos.
            </p>
          </div>

          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              Vivir juntos siendo diferentes puede ser una{" "}
              <strong>ventaja</strong>: tenemos más costumbres, ideas y
              experiencias de las cuales aprender.{" "}
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen5} className="img-fluid w-100" alt="Peruanos" />
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>Lea el texto titulado ¿Cómo convivimos siendo diferentes?</li>

          <li>
            Resalte que, a pesar de las diferencias que tenemos entre peruanos
            (de dónde venimos, cómo hablamos, cómo somos), todos tenemos los
            mismos derechos. Este reconocimiento resulta fundamental para
            nuestra convivencia. Convivir requiere de aceptar y valorar la
            diversidad.
          </li>

          <li>
            Cierre el tema conversando con los niños y las niñas acerca de qué
            problemas vistos en esta unidad dificultan la convivencia en el
            país, por ejemplo: la discriminación y la exclusión.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
